import React, { useState, useRef } from 'react';
import Select from 'react-select';
import { searchProducts } from "../../../../../api/products";
import { formatCurrencyValue } from "../../../../../utils";

export default function BarcodeAutoComplete(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [inputValue, setInputValue] = useState('');
    
    const timeoutRef = useRef(null);

    const loadOptions = (query) => {
        if (!query) {
            setOptions([]);
            return;
        }

        setIsLoading(true);

        let params = {};
        
        if (isNaN(query)) {
            params["name"] = query;
        } else {
            if (query.length >= 8) {
                params["barcode"] = query;
            } else {
                params["code"] = query;
            }
        }
        searchProducts(params)
            .then(result => {
                const formattedOptions = result.map(item => {
                    const price = formatCurrencyValue(item.sellable.price);
                    const name = item.sellable ? item.sellable.name : (item.name || "Sem Nome");
                    
                    return {
                        value: item.id,
                        label: `${name} - ${price}`, 
                        original: item 
                    };
                });
                setOptions(formattedOptions);
            })
            .catch(err => {
                console.error("Erro na busca", err);
                setOptions([]);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleInputChange = (newValue, actionMeta) => {
        if (actionMeta.action !== "input-change") return;

        setInputValue(newValue);

        if (newValue.length > 0) {
            setIsLoading(true);
        } else {
            setIsLoading(false);
        }

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            loadOptions(newValue);
        }, 100);
    };

    const handleSelect = (selectedOption) => {
        if (props.onSelect && selectedOption) {
            props.onSelect({ 
                value: selectedOption.value, 
                label: selectedOption.label,
                original: selectedOption.original
            });
        }
    };

    return (
        <div style={{ marginBottom: '10px' }}>
            <Select
                id="pos-smart-select"
                placeholder="Digite aqui"
                components={{ LoadingIndicator: null }}
                inputValue={inputValue}
                onInputChange={handleInputChange}
                
                onChange={handleSelect}
                options={options}
                
                isLoading={isLoading}
                noOptionsMessage={({ inputValue }) => 
                    inputValue.length > 0 ? "Nenhum produto encontrado" : "Digite para buscar..."
                }
                loadingMessage={() => "Carregando..."}
                                
                isClearable
            />
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Barcodes/components/AutoComplete/index.jsx